import { IdToPatientExtraInfo } from '../../ts';

export const getExtraInfoArray = <T>(idToPatientExtraInfo: IdToPatientExtraInfo<T> | undefined) => {
  if (idToPatientExtraInfo == null) return undefined;
  return Object.values(idToPatientExtraInfo).flat();
};
